<template>
  <v-menu
    v-model="menu"
    transition="slide-y-transition"
    :close-on-content-click="false"
    offset-y>
    <v-btn
      slot="activator"
      icon
      flat
      small>
      <v-icon>sentiment_satisfied_alt</v-icon>
    </v-btn>

    <v-card class="emoji-card">
      <v-text-field
        class="emoji-card__search"
        v-model="keyword"
        color="black"
        placeholder="搜尋"
        prepend-inner-icon="search"
        clearable/>

      <div ref="emojiList" class="emoji-card__list">
        <div
          class="emoji-card__list-item"
          :title="emoji.shortName"
          :key="index"
          @click="onEmojiClick(emoji)"
          v-for="(emoji, index) in emojis">
          {{emoji.value}}
        </div>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import emojis from '@/assets/emojis';
import SingleElementIntersectionObserver from '@/lib/single-element-intersection-observer';

export default {
  data() {
    return {
      menu: false,
      keyword: '',
      // {id, value, category, subCategory, shortName}
      emojis: [],
      page: 0,
      pageSize: 20
    };
  },

  computed: {
    filteredEmojis() {
      return emojis.filter(emoji => {
        if (!this.keyword) {
          return true;
        }

        let keyword = this.keyword.toLowerCase();
        if (keyword.trim() === '') {
          return true;
        }
        if (emoji.category.toLowerCase().indexOf(keyword) > -1) {
          return true;
        }
        if (emoji.subCategory.toLowerCase().indexOf(keyword) > -1) {
          return true;
        }
        if (emoji.shortName.toLowerCase().indexOf(keyword) > -1) {
          return true;
        }
        return false;
      });
    }
  },

  watch: {
    keyword() {
      this.resetSearchResults();
      this.loadNextPage();
    }
  },

  mounted() {
    this._intersectionObserver = new SingleElementIntersectionObserver(this.loadNextPage.bind(this), {
      threshold: 0.5
    });
    this.loadNextPage();
  },

  beforeDestroy() {
    this._intersectionObserver.disconnect();
  },

  methods: {
    resetSearchResults() {
      this.page = 0;
      this.emojis = [];
    },

    async loadNextPage() {
      let total = this.filteredEmojis.length;
      let offset = this.page * this.pageSize;
      if (offset > total) {
        return;
      }
      let end = offset + this.pageSize;
      end = end > total ? total : end;
      for (let i = offset; i < end; i++) {
        this.emojis.push(this.filteredEmojis[i]);
      }
      this.page++;
      await this.$nextTick();
      this._intersectionObserver.observe(this.$refs.emojiList.lastChild);
    },

    onEmojiClick(emoji) {
      this.$emit('input', emoji.value);
      this.menu = false;
    }
  }
};
</script>

<style lang="stylus" scoped>

.emoji-card {
  width: 30vw;
  height: 40vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0 1rem 1rem 1rem;
  background-color: white;
}

.emoji-card__search {
  flex-grow: 0;
  flex-shrink: 0;
}

.emoji-card__list {
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  flex-grow: 1;
  align-content: flex-start;
}

.emoji-card__list-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0.5rem;
  transition: 0.1s;
  cursor: pointer;

  &:hover {
    background-color: $def-hover-color;
    transform: scale(1.3);
  }
}

</style>
